import React, { Fragment, useState, useEffect } from 'react';
import ImageItem from './imageitem';

const ImageDisplay = (props) => {
    const [scrollArrow, setScrollArrow] = useState(<i className="fa fa-sort-desc fa-4x fa-beat" id="scroll-indicator" aria-hidden="true"></i>)
    const [resetButton, setResetButton] = useState(<button className="button lurebuilder-button reset-button" onClick={(e) => props.resetCategory(props.category)}>Reset category</button>)
    
    const getSelectedImage = (index) => {
        const { selImg, hasSubCategories, category } = props;
        if (hasSubCategories) {
            return selImg.filter(img => {
                return img.category === category;
            })[0].subCategories;
        } else {
            return selImg.filter(img => {
                return img.category === category;
            })[0].selectedImage;
        }
    }

    /**
     * Handles wether or not the reset button should be clickable, depending on if any layer
     * has been selected for the current category
     */
    const hasSelectedLayer = () => {
        const { selImg, category, hasSubCategories } = props;
        const currentCategory = selImg.filter(i => i.category === category )[0];
        if (currentCategory !== undefined) {
            if (!hasSubCategories) {
                if (currentCategory.selectedImage !== -1) { return true }
            } else {
                if (currentCategory.subCategories.filter(c => c.selectedImage != -1).length !== 0) { return true }
            }
        }
        return false;
    }

    const handleScroll = (element) => {
        if( element.scrollTop > (element.scrollHeight - element.offsetHeight) * 0.25) {
            setScrollArrow(null);
        } else {
            setScrollArrow(<i className="fa fa-sort-desc fa-4x fa-beat" id="scroll-indicator" aria-hidden="true"></i>);
        }
    }

    /**
     * Assigns subcategory ids (from categoryconstants.js) to the images for sorting purposes,
     * then sorts and returns the image array.
     * @param {*} images 
     */
    const sortSubCategories = images => {
        const { selImg } = props;
        let cat = selImg.find(img => img.category === props.category);
        if (cat) {
            if (navigator.userAgent.indexOf("Firefox") !== -1) {
                images.reverse();
            }
            return images.map(img => {
                return {
                    ...img,
                    subCategoryId: cat.subCategories.find(c => img.category === c.category).id
                }
            }).sort((a, b) => (parseFloat(a.subCategoryId) < parseFloat(b.subCategoryId)) ? -1 : 1);
        }
        return images;
    }

    let heading;
    let index = 0;
    return (
        <>
            <div className="lurebuilder-wizard-header-container">
                <h3 className="lurebuilder-wizard-header" style={{display: 'inline'}}>{props.category}</h3>
            <button className={`button lurebuilder-button reset-button ${hasSelectedLayer() ? "" : "lurebuilder-button-disabled"}`} onClick={(e) => props.resetCategory(props.category)} disabled={!hasSelectedLayer()}>Reset category</button>
            </div>
            <div className="lurebuilder-image-list-container" id="lb-img-list-container" >
                <ul className="lurebuilder-image-list">
                    {props.hasSubCategories ?
                        (props.images ? sortSubCategories(props.images).map((img, i) => {
                            if (img.category === heading) {
                                index++;
                                return (
                                    <ImageItem
                                        key={`img-item-${img.category}-${index}`}
                                        img={img}
                                        i={`${img.category}-${index}`}
                                        isSelected={getSelectedImage().filter(el => el.category === img.category)[0].selectedImage}
                                        handleImageClick={props.handleImageClick}
                                        isActive={img.Active}
                                    />
                                )
                            } else {
                                heading = img.category;
                                index = 0;
                                return (
                                    <Fragment key={`fragment-${img.category}-${index}`}>
                                        <div className="break"></div>
                                        <h4 className={`image-list-heading`} key={`img-heading-${img.category}-${index}`}>{img.category}</h4>
                                        <div className="break"></div>
                                        <ImageItem
                                            key={`img-item-${img.category}-${i}`}
                                            img={img}
                                            i={`${img.category}-${index}`}
                                            isSelected={getSelectedImage().filter(el => el.category === img.category)[0].selectedImage}
                                            handleImageClick={props.handleImageClick}
                                            isActive={img.Active}
                                        />
                                    </Fragment>
                                )
                            }
                        }) : null) :
                        (props.images ? props.images.map((img, i) => {
                            return (
                                <ImageItem key={`img-item-${i}`} img={img} i={i} isActive={img.Active} isSelected={getSelectedImage()} handleImageClick={props.handleImageClick} />
                            )
                        }) : null)
                    }
                </ul>
            </div>
        </>

    );
}

export default ImageDisplay;